import React, { useEffect, useState } from 'react'
import List from '../../componentes/lista'
import { Container , Card } from './styles'
import toast from 'react-hot-toast';
import ConnectPainel from '../../apis/adm/painel';
import CRUDPainel from '../../componentes/crud-painel';
import ConnectAreaNegocio from '../../apis/adm/areanegocio';


const Painel = (props)=>{

    const service = new ConnectPainel()
    const serviceAreaNegocio = new ConnectAreaNegocio()
    const [Paineis,setPaineis]=useState([])
    const [offset,setOffset]=useState(0)
    const [paginaAtual,setPaginaAtual]=useState(1)
    const [maximoPaginas,setMaximoPaginas]=useState(1)
    const [idPainel,setIdPainel]=useState(-1)
    const [abrirComponente,setAbrirComponente]=useState(false)
    const [id,setId]=useState("")
    const [nome,setNome]=useState("")
    const [idAreaNegocio,setIdAreaNegocio]=useState("")
    const [nomeAreaNegocio,setNomeAreaNegocio]=useState("")
    const [nomeOperacao,setNomeOperacao]=useState("")
    const [option,setOption]=useState([])

    useEffect(async()=>{
        if(props.paginaAtiva===null){
            window.location.href="/adm"
            return 0
        }
        await ConsultarAreaNegocio()
        await ConsultarPainel()
    },[])

    useEffect(async()=>{
        setPaineis([])
        await ConsultarPainel()
    },[offset])

    useEffect(()=>{
        if(paginaAtual>maximoPaginas){
            setPaginaAtual(1)
            setOffset(0)
        }
    },[maximoPaginas])

    useEffect(()=>{
        if(option.length>0){
            gravarIdArea()
        }
    },[option])

    useEffect(()=>{
        if(idPainel===null){
            setId("")
            setNome("")
            setNomeOperacao("INSERÇÂO")
            gravarIdArea()
            setAbrirComponente(true)
            return 0
        }
        for(let i in Paineis){
            if(Paineis[i].id === idPainel){
                setId(Paineis[i].id)
                setNome(Paineis[i].nome)
                setNomeOperacao("ALTERAÇÃO")
                setIdAreaNegocio(Paineis[i].idareanegocio)
                setNomeAreaNegocio(Paineis[i].nomeareanegocio)
                setAbrirComponente(true)
                return 0
            }
        }
    },[idPainel])

    const validarInfos = () =>{
        if(nome===""){
            toast.error("Informe o nome do painel")
            return false
        }
        return true
    }

    const gravarIdArea = () =>{
        setIdAreaNegocio(option[0].id)
        setNomeAreaNegocio(option[0].nome)
    }

    const ConsultarPainel = async()=>{
        try{
            let url = "idpainel=null&nomepainel=null&idareanegocio=null&ativo=true&offset="+offset
            let result = await service.consultarPainel(url)
            if(result.status===200){
                setPaineis([])
                let arrendondar = Math.ceil(result.data.count/6);
                if(arrendondar===0){
                    arrendondar=1
                }
                setMaximoPaginas(arrendondar)
                setPaineis(result.data.data)
            }
        }
        catch(error){
            toast.error(error.response.data.msg)
        }
    }

    const ConsultarAreaNegocio = async()=>{
        try{
            let url = "idareanegocio=null&nomeareanegocio=null&ativo=true&offset=0"
            let result = await serviceAreaNegocio.listAreaNegocio(url)
            if(result.status===200){
                //console.log(result.data.data)
                setOption(result.data.data)
            }
        }
        catch(error){
            toast.error(error.response.data.msg)
        }
    }

    const CriarPainel = async()=>{
        try{
            if(validarInfos()){
                let result = await service.criarPainel({
                    "nomepainel":nome,
                    "idareanegocio":idAreaNegocio
                })
                if(result.status===201){
                    toast.success("Inserido novo painel")
                    await ConsultarPainel()
                    CancelarOperacao()
                }
            }
        }
        catch(error){
            toast.error(error.response.data.msg)
        }
    }

    const DeletarPainel = async()=>{
        try{
            if(validarInfos()){
                let url = "idpainel="+id
                let result = await service.deletePainel(url)
                if(result.status===200){
                    toast.success("Deletado painel")
                    await ConsultarPainel()
                    CancelarOperacao()
                }
            }
        }
        catch(error){
            toast.error(error.response.data.msg)
        }
    }

    const AlterarPainel = async()=>{
        try{
            if(validarInfos()){let result = await service.alterarPainel({
                    "idpainel":id,
                    "nomepainel":nome,
                    "idareanegocio":idAreaNegocio
                })
                if(result.status===200){
                    toast.success("Alterado painel")
                    await ConsultarPainel()
                    CancelarOperacao()
                }
            }
        }
        catch(error){
            toast.error(error.response.data.msg)
        }
    }

    const CancelarOperacao = () =>{
        setAbrirComponente(false)
        setId("")
        setNome("")
        setNomeOperacao("")
        setIdPainel(-1)
    }


    return(
        <Container>
            <Card>
                <List data={Paineis} isCrudUsuario={false} coluna1="ID" coluna2="NOME" nomePagina="DASHBOARD"
                  paginaAtual={paginaAtual} setPaginaAtual={setPaginaAtual} 
                  paginaFinal={maximoPaginas} offset={offset} setOffset={setOffset}
                  setAbrirCrud={setIdPainel} />
            </Card>
            <Card>
                {abrirComponente &&(
                    <CRUDPainel id={id} setId={setId} nomeOperacao={nomeOperacao}
                     nome={nome} setNome={setNome} option={option} 
                     nomeAreaNegocio={nomeAreaNegocio} setNomeAreaNegocio={setNomeAreaNegocio}
                     idAreaNegocio={idAreaNegocio} setIdAreaNegocio={setIdAreaNegocio}
                     CancelarOperacao={CancelarOperacao} AlterarPainel={AlterarPainel}
                     DeletarPainel={DeletarPainel} CriarPainel={CriarPainel}/>
                )}
            </Card>
        </Container>
    )
}

export default Painel